import { FelaCSS } from '@bridebook/ui';
import {
  AI_PLANNER_DOCK_MOTION,
  AI_PLANNER_DOCK_WIDTH,
  AI_PLANNER_DOCK_WIDTH_VAR,
  AI_PLANNER_PANEL_WIDTH,
} from '@bridebook/web/lib/ai-planner/constants';

// Types the dock width, so it can be animated: the page and its fixed bars
// then narrow beside the docked planner in step
if (typeof window !== 'undefined' && 'registerProperty' in CSS) {
  try {
    CSS.registerProperty({
      name: AI_PLANNER_DOCK_WIDTH_VAR,
      syntax: '<length-percentage>',
      inherits: true,
      initialValue: '0px',
    });
  } catch {
    // Already registered, e.g. after a hot reload
  }
}

interface IStyles {
  containerContentWrap: FelaCSS;
}

interface IStyleArgs {
  isPlannerDocked: boolean;
  isPlannerExpanded: boolean;
  // Off for a planner restored from an earlier visit, which docks in place
  isPlannerAnimated: boolean;
}

const styles = ({ isPlannerDocked, isPlannerExpanded, isPlannerAnimated }: IStyleArgs): IStyles => {
  const { openMs, closeMs, easing } = AI_PLANNER_DOCK_MOTION;

  return {
    containerContentWrap: {
      flexGrow: 1,
      // Narrows the page beside the docked planner. Fixed children keep the
      // viewport as their containing block, so a transform must not be used
      // here; they read the dock width from the custom property and narrow
      // themselves. Animating the typed property moves them all in step
      // with the page.
      [AI_PLANNER_DOCK_WIDTH_VAR]: isPlannerDocked ? AI_PLANNER_PANEL_WIDTH : '0px',
      width: `calc(100% - ${AI_PLANNER_DOCK_WIDTH})`,
      // Clips content that still assumes the full viewport width
      ...(isPlannerDocked && { overflowX: 'clip' }),
      // Fades away beneath the planner stretched over the whole screen
      opacity: isPlannerExpanded ? 0 : 1,
      // A restored planner docks in place, but stretching it later still fades the page
      transition: [
        isPlannerAnimated &&
          `${AI_PLANNER_DOCK_WIDTH_VAR} ${isPlannerDocked ? openMs : closeMs}ms ${easing}`,
        'opacity 260ms ease',
      ]
        .filter(Boolean)
        .join(', '),
    } as FelaCSS,
  };
};

export default styles;
